import React from "react";
import PieChart from "./PieChart";
import PieLabels from "./PieLabels";
import Lines from "./Lines";
import MobilePieLabels from "./MobilePieLabels";

export default function TokonomicsLayout() {
  return (
    <div
      className="text-white md:pt-44 lg:pt-24 xl:pt-40 
    flex flex-col mx-auto items-center font-Helvetica 
    max-w-[400px] sm:max-w-[600px] md:scale-[1.2] lg:max-w-none
    2xl:scale-100  xl:scale-[0.95] lg:scale-[0.76] 
    max-[400px]:scale-[0.8] max-[400px]:pt-0 pt-32"
    >
      <div className="font-Red-Undead text-center text-4xl lg:text-6xl uppercase">
        TOKEN
        <br className="lg:hidden" /> DISTRIBUTION
      </div>
      <div className="flex flex-col lg:hidden">
        <MobilePieLabels />
      </div>

      <div className="lg:block hidden relative  mt-32 lg:mt-40 xl:mt-52 xl:mb-16 ">
        <div className="bg-[#05FF00] absolute top-0 h-[400px] w-[400px] bg-opacity-50 blur-[164px]" />
        <div className="pointer-events-none mx-auto ">
          <PieChart />
        </div>
        <PieLabels />
        <Lines />
      </div>
    </div>
  );
}
